import { t } from "i18next";

export const getGraphTitle = (data, type) => {
  switch (type) {
    case "dashboard-graph":
      return (
         <>
           <span className="graph-title">{`${data?.name} ${t("site.site")} ${data?.site?.name}`}</span>
           {data?.timeRange ? <span className="graph-description">({data?.timeRange?.name})</span> : null}
         </>
      )
    case "dashboard-statistic":
      return (
         <span className="graph-title">{`${data?.name} ${t("site.site")} ${data?.site?.name}`}</span>
      )
      case "report-chart":
        return (
           <>
             <div className="graph-title">
              {`${data.ip === "all" ? t("site.all_sites") : `${t("site.site")} ${data?.site?.name}`} - ${data?.item?.name}`}
             </div>
             <div className="graph-description mt-1">({data?.timeRange})</div>
           </>
        )
  }
}